module.exports = __webpack_public_path__ + "img/complaint-socmed.512f7233.png";